import React from 'react';

import {A} from '@br/mg-components';

/*
An extra login link which is displayed underneath the normal array of OIDC
login links with less prominence.
*/
const ExtraLoginLink = ({url, name}: {url: string; name: string}): JSX.Element => {
    return (
        <A
            href={url}
            // eslint-disable-next-line react/forbid-component-props
            forceRedirect
            className="d-block text-center caption-small mt-4"
        >
            {name}
        </A>
    );
};

export default ExtraLoginLink;
